var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.component)?_c(_vm.component,{ref:_vm.id,tag:"component",staticClass:"app-item-dyn",attrs:{"item":_vm.item,"type":_vm.type,"value":_vm.iri},on:{"saved":_vm.onSaved}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }